module.exports = __webpack_public_path__ + "media/flags/kg-ad800fbd.svg";